import { createI18n } from 'vue-i18n'
import { defaultLocale, i18nMessages, type Locale, supportedLocales } from '@/app/i18n/locales'

const STORAGE_KEY = 'joja-locale'

const isLocale = (value: string | null): value is Locale =>
  Boolean(value && supportedLocales.includes(value as Locale))

// Only an explicit choice from the switcher moves us off Uzbek — the browser language is
// deliberately ignored, since an en/ru browser is not a signal that the user wants that locale.
const detectLocale = (): Locale => {
  if (typeof window === 'undefined') return defaultLocale

  const savedLocale = window.localStorage.getItem(STORAGE_KEY)
  return isLocale(savedLocale) ? savedLocale : defaultLocale
}

export const i18n = createI18n({
  legacy: false,
  locale: detectLocale(),
  fallbackLocale: defaultLocale,
  messages: i18nMessages,
})

export const setLocale = (locale: Locale) => {
  i18n.global.locale.value = locale
  document.documentElement.lang = locale
  window.localStorage.setItem(STORAGE_KEY, locale)
}

export const setupLocale = () => {
  setLocale(i18n.global.locale.value)
}
